/* eslint-disable import/prefer-default-export */

'use client';

import { ColumnDef } from '@tanstack/react-table';
import { format } from 'date-fns';
import PaymentStatusBadge from '../../../components/ui/badge';

import { IInvoice } from '../../../types/types';

import Checkbox from '../../../components/ui/checkbox';

export const columns: ColumnDef<IInvoice>[] = [
  {
    id: 'select',
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllPageRowsSelected() || (table.getIsSomePageRowsSelected() && 'indeterminate')}
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: 'invoice_number',
    header: 'Invoice No.',
    cell: ({ row }) => <div>{row.getValue('invoice_number')}</div>,
  },
  {
    accessorKey: 'status_payment',
    header: () => <div>Payment Status</div>,
    cell: ({ row }) => <PaymentStatusBadge status={row.getValue('status_payment')} />,
  },
  {
    accessorKey: 'amount_due',
    header: () => <div className="text-center">Amount</div>,
    cell: ({ row }) => {
      const amount = parseFloat(row.getValue('amount_due'));

      const formatted = new Intl.NumberFormat('id-ID', {
        style: 'currency',
        currency: 'IDR',
      }).format(amount);

      return <div className="text-right font-medium">{formatted}</div>;
    },
  },
  {
    accessorKey: 'date',
    header: () => <div>Invoice Date</div>,
    cell: ({ row }) => {
      const formattedDate = format(row.getValue('date'), 'LLL dd, y');
      return <div>{formattedDate}</div>;
    },
  },
  {
    accessorKey: 'due_date',
    header: () => <div>Due Date</div>,
    cell: ({ row }) => {
      const formattedDate = format(row.getValue('due_date'), 'LLL dd, y');
      return <div>{formattedDate}</div>;
    },
  },
];
